import {
    ADD_SKILLS_REQUEST,
    ADD_SKILLS_SUCCESS,
    ADD_SKILLS_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const AddSkillsAction = (data) => {
    return function (dispatch) {
      
      dispatch({
        type: ADD_SKILLS_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_skills`,
        method: "POST",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          
          console.log(res.data.status.message, "newdata Avdesh newwwwwww");
          dispatch(CreateJobFormPre(res.data));
          //  localStorage.setItem("userInfo", JSON.stringify(res.data));
          //   window.location.href = "/";
        })
        .catch((error) => {
          dispatch({
            type: ADD_SKILLS_FAIL,
            payload: false,
            error: error,
            createJob: error.success,
            msg: "Failed to create user registration",
          });
          toast.error(error.msg);
        });
    };
  };
  
  export const CreateJobFormPre = (data) => {
    toast.success("Add Skills Successfully.");
    // setTimeout(()=>{
    //     window.location.href = "/candidate_dashboard";
    //  },2000)
    return {
      type: ADD_SKILLS_SUCCESS,
      createJob: data.status.message,
      result: data,
      payload: false,
      msg: data.status.message,
    };
  };

